var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.popupOpened)?_c('NewsPopup',{key:_vm.id,attrs:{"show":_vm.popupOpened,"id":_vm.id},on:{"update:show":function($event){_vm.popupOpened=$event}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }